module.exports = __webpack_public_path__ + "img/sidebtn.8ef40033.png";